import Attendance from '../../modules/class/Attendance/AttendancePage';

const AttendancePage = () => {
  return <Attendance />;
};

export default AttendancePage;
